import { NewTranslationKeys } from '~/data/customTranslations';
import { fetchFromNewApi } from '~/services/Http';

export type TranslationSubmitData = {
  term?: NewTranslationKeys;
  translations: { locale: string; translation: string }[];
};

export const submitTranslationData = async (
  languageTerms: TranslationSubmitData,
  term: NewTranslationKeys,
) => {
  return await fetchFromNewApi(`/i18n/translations/terms/${term}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(languageTerms),
  });
};

export const getTermTranslation = async (term: string) =>
  await fetchFromNewApi(`/i18n/translations/terms/${term}`).then((data) =>
    data.json(),
  );
